import { useEffect, useState } from 'react'

const MODAL_MARGINS = 50

const useModalWidthResizer = () => {
  const [modalWidth, setModalWidth] = useState(640)

  const resizeModalHandler = () => {
    if (window.innerWidth < 800) {
      setModalWidth(window.innerWidth - MODAL_MARGINS)
    } else {
      setModalWidth(640)
    }
  }

  useEffect(() => {
    if (window.innerWidth < 800) {
      setModalWidth(window.innerWidth - MODAL_MARGINS)
    }
    window.addEventListener('resize', resizeModalHandler)
    return () => window.removeEventListener('resize', resizeModalHandler)
  }, [])

  return modalWidth
}

export default useModalWidthResizer
